import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLangPrefix } from "../i18n";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const lp = useLangPrefix();
  if (!user) return <Navigate to={`${lp}/login`} replace />;
  return children;
}
